import mutations from "@/store/mutations/horoSopeMutation";
import getters from "@/store/getters/horoSopeGetter";
/**
 *  mask
 */

export default {
  state: {
    horoScopeTime: null,
    horoscope: null,
    todayHoroscopeFate: null,
    tomorrowHoroscopeFate: null,
    weekHoroscopeFate: null,
    monthHoroscopeFate: null,
    yearHoroscopeFate: null,
    dailyPlamistryData: null
  },
  mutations: mutations,
  getters: getters
};